/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';
import _ from 'underscore';

import * as benchlingUtil from 'BenchlingUtil';
import {openLink} from 'link-preview/LinkUtil';
import {omit} from 'util/omitKey';
import {ElementMouseEvent, Optional} from 'util/Types';

import LinkActions from './LinkActions';

export interface BenchLinkProps {
  className?: string;
  href: string;
  // If specified, this is the ID of the file to open upon click. If unspecified, the ID will be
  // inferred from the href via the LinkStore.
  fileId?: Optional<string>;
  onClick?: never;
  target?: never;
  children: React.ReactNode;
  stopPropagation?: boolean;
}

export default class BenchLink extends React.Component<BenchLinkProps> {
  /**
   * Opens the URL within Benchling if the URL was processed by the LinkStore and the user did not
   * ctrl-click. Otherwise, opens the URL in a new tab.
   *
   * Note: This method directly accesses the LinkStore so it should NOT be used in a render method,
   * only in event handlers.
   */
  onClick = (e: ElementMouseEvent): void => {
    if (!benchlingUtil.isSimpleClick(e)) {
      return;
    }

    if (this.props.stopPropagation) {
      e.stopPropagation();
    }

    e.preventDefault();
    openLink(this.props.href);
  };

  override componentDidMount(): void {
    const added = [this.props.href];
    const removed: Array<string> = [];
    // Avoid triggering action in the same stack as an action that is causing this component to be mounted.
    _.defer(() => {
      LinkActions.syncLinks(added, removed);
    });
  }

  override UNSAFE_componentWillReceiveProps(nextProps: BenchLinkProps): void {
    if (this.props.href === nextProps.href) {
      return;
    }
    const added = [nextProps.href];
    const removed = [this.props.href];
    // Avoid triggering action in the same stack as an action that is causing this component to be updated.
    _.defer(() => {
      LinkActions.syncLinks(added, removed);
    });
  }

  override componentWillUnmount(): void {
    const added: Array<string> = [];
    const removed = [this.props.href];
    // Avoid triggering action in the same stack as an action that is causing this component to be unmounted.
    _.defer(() => {
      LinkActions.syncLinks(added, removed);
    });
  }

  override render(): JSX.Element {
    return (
      <a
        {...omit(this.props, 'fileId', 'stopPropagation')}
        onClick={this.onClick}
        target="_blank"
        rel="noopener noreferrer"
      />
    );
  }
}
